import { FC } from 'react';
import styled from 'styled-components';
import { Box } from '../../components';

const StyledCodeBlock = styled(Box)`
  border: 1px solid;
  border-color: ${({ theme }) => theme.colors.borderGray};
  overflow: auto;
  max-height: 450px;
`;

export const CodeBlock: FC<{}> = ({ children }) => {
  return (
    <StyledCodeBlock
      as="pre"
      p={3}
      fontSize="15px"
      backgroundColor="neutral.1"
      fontFamily="mono"
      borderRadius="6px"
      mb="sm"
    >
      {children}
    </StyledCodeBlock>
  );
};
